export const ROUTES = {
  ONBOARDING: 'Onboarding',
  WELCOME: 'Welcome',
  OTP_VERIFICATION: 'OTP Verification',
  NOT_ALLOWED: 'Not Allowed',
  MAINTENANCE: 'Maintenance',
  AUTHENTICATION: 'Authentication',
  APPLICATION: 'Application',

  ADD_ACCOUNT: 'Add Account',
  ROOT: 'Root',
  PDF_VIEWER: 'Pdf Viewer',
  NOTIFICATION_MODAL: 'Notification Modal',
  HOME: 'Home',
  CONTENT: 'Content',

  // Knowledge
  KNOWLEDGE: 'Knowledge',
  KNOWLEDGE_HUB: 'Knowledge Hub',
  KNOWLEDGE_HUB_WORKSPACES: 'Knowledge Hub Workspaces',
  KNOWLEDGE_HUB_DIRECTORY: 'Knowledge Hub Directory',
  KNOWLEDGE_HUB_BINDER: 'Knowledge Hub Binder',
  KNOWLEDGE_HUB_CONTENT_VIEWER: 'Knowledge Hub Content Viewer',
  KNOWLEDGE_HUB_SEARCH: 'Knowledge Hub Search',
  KNOWLEDGE_HUB_ITEM_INFO: 'Knowledge Hub Item Info',
  CONTENT_ITEM: 'Knowledge list',
  ITEMS: 'Knowledge items',
  CONTENT_VIEWER: 'Content viewer',
  ADD_KEYWORDS: 'Add keywords',
  REPORT_PROBLEM: 'Report problem',
  SUGGEST_CONTENT: 'Suggest content',
  IMAGE_VIEWER: 'Image Viewer',
  KNOWLEDGE_ATTACHMENT: 'Knowledge Attachment',

  // Contacts
  CONTACTS: 'Contacts',
  CONTACTS_ITEMS: 'Contacts Items',

  CHECKLISTS: 'Checklists',
  CHECKLISTS_CATEGORY: 'Checklists Category',
  CHECKLISTS_ITEMS: 'Checklists Items',
  CHECKLISTS_REPORT: 'Checklists Report',

  LABS: 'Labs',
  LABS_CATEGORY: 'Labs Category',
  LABS_ITEMS: 'Labs Items',
  FAVORITES: 'Favorites',
  SEARCH: 'Search',

  USER_PROFILE: 'Profile',
  USER_PROFILE_POPUP: 'Profile Popup',
  REPORT_ISSUE: 'Report Issue',

  TABS: 'Tabs',
  TAB_HOME: 'Home Tab',
  TAB_CONTACTS: 'Contacts Tab',
  TAB_KNOWLEDGE: 'Knowledge Tab',
  TAB_CHECKLISTS: 'Checklists Tab',
  TAB_LABS: 'Labs Tab',
  TAB_FAVORITES: 'Favorites Tab',
  TAB_SEARCH: 'Search Tab',
  TAB_ROTATIONS: 'Rotations Tab',
  TAB_MORE: 'More Tab',
  TAB_CONTENT: 'Content Tab',

  ROTATIONS: 'Rotations',
  ROTATION_ITEM: 'Rotation Item',

  ASK_PANDA: 'Ask Panda',

  OAUTH_CALLBACK_SAML: 'auth/callback/saml',

  NOTIFICATIONS: 'Notifications',
  NOTIFICATION_ITEM: 'Notification Item',

  MY_SCHEDULE: 'My Schedule',
  CLINICAL_ASSIGNMENTS: 'Clinical Assignments',
  EDUCATIONAL_EVENTS_LIST: 'Educational Events List',
  EVENT_DETAILS: 'Event Details',
  CASE_DETAILS: 'Case Details',
  ADD_ASSIGNMENT: 'Add Assignment',

  EDUCATIONAL_EVENT_DETAILS: 'Educational Event Details',
  EDUCATIONAL_EVENT_CREATE: 'Educational Event Create',
  EDUCATIONAL_EVENT_EDIT: 'Educational Event Edit',
  CHECK_IN_ACTIVE: 'Check-in Active',
  CHECK_IN_CLOSED: 'Check-in Closed',
  CHECKED_IN_ATTENDEES: 'Checked-in Attendees',
  SCAN_QR: 'Scan QR',
  COMPLETE_CHECK_IN: 'Complete Check-in',
  CHECK_IN_RESULT: 'Check-in Result',

  QUALITY_METRIC: 'Quality Metric',
  QUALITY_METRIC_CASE: 'Quality Metric Case',

  BIOMETRIC_UNLOCK: 'Biometric Unlock',
  BIOMETRIC_ENROLLMENT: 'Biometric Enrollment',

  ORGANIZATION_SELECTOR: 'Organization Selector',

  DEEP_LINK_REDIRECT: 'Deep Link Redirect',
};
